import React, {useEffect, useRef, useState} from "react"
import clsx from 'clsx'
import {CabecalhoLogo} from "../cabecalho-logo/CabecalhoLogo"
import {Vendedor} from "../../types/Vendedor";

const estilosCaixaDialogoPadrao = require('../../estilos/caixa-dialogo-padrao.module.scss').default
const estilosBotoes = require('../../estilos/botoes.module.scss').default
const estilosIniciarOrcamento = require('./iniciar-orcamento.module.scss').default

export type IniciarOrcamentoProps = {
    filiais: {
        Oid: number,
        Descricao: string
    }[]
    onCancelar: () => void
    onEntrar: (oidFilial: number) => void
    oidFilialSelecionada: number
    vendedorLogado: Vendedor
    urlLogo?: string
    realizandoProcessamento: boolean;
    desativarAlteracaoFilial: boolean
}

export const IniciarOrcamento = (props: IniciarOrcamentoProps) => {
    const [oidFilialSelecionada, setOidFilialSelecionada] = useState(props.oidFilialSelecionada)

    useEffect(() => {
        document.getElementById("iniciar-orcamento-botao-entrar").focus()
    }, [])

    return <>
        <div className={clsx(estilosCaixaDialogoPadrao.container, estilosCaixaDialogoPadrao.caixaFlutuante)}
            id="IniciarOrcamento_CaixaDialogo"
        >
            <CabecalhoLogo urlLogo={props.urlLogo}/>

            <div className={estilosCaixaDialogoPadrao.corpo}>
                <div className="_flex _flex-col _ml-8 _mt-8"
                    id="IniciarOrcamento_Vendedor_Container"
                >
                    <span className={estilosIniciarOrcamento.legenda}>Vendedor</span>
                    <span
                        id="IniciarOrcamento_spanVendedor"
                    >{props.vendedorLogado.Nome}</span>
                </div>

                <div className="_flex _flex-col _ml-8 _mt-8"
                    id="IniciarOrcamento_ UltimoOrcamento_Container"
                >
                    <span className={estilosIniciarOrcamento.legenda}>Último Orçamento</span>
                    <span
                        id="IniciarOrcamento_spanFilial"
                    >Filial: {props.vendedorLogado.FilialUltimoPedido} / Número: {props.vendedorLogado.UltimoPedido}</span>
                </div>

                <div className="_flex _flex-col _ml-8 _mt-8"
                    id="IniciarOrcamento_ComboBoxFilial_Container"
                >
                    <span className={estilosIniciarOrcamento.legenda}>Filial</span>
                    <select
                        disabled={props.desativarAlteracaoFilial || props.realizandoProcessamento}
                        id="IniciarOrcamento_ComboBoxFilial"
						title="Veja parametros:&#013;-Permitir alterar a filial do orçamento&#013;-Permitir o gerente alterar a filial do orçamento"
                        onChange={e => setOidFilialSelecionada(Number(e.target.value))}
                        value={(oidFilialSelecionada) ?? ""}
                        className="_w-9/12">
                        {props.filiais.map(f => <option value={f.Oid}
                                    key={ `IniciarOrcamento_ComboBoxFilial${f.Oid}`}
                                    id={ `IniciarOrcamento_ComboBoxFilial${f.Oid}`}
                                >{f.Descricao}</option>)}
                    </select>
                </div>

                <div className="_flex _flex-row _ml-8 _gap-x-4 _mt-4"
                    id="IniciarOrcamento_Botoes"
                >
                    <button className={estilosBotoes.botaoPrimario}
                            disabled={props.realizandoProcessamento}
                            type="submit"
                            onClick={() => props.onEntrar(oidFilialSelecionada)}
                            id="iniciar-orcamento-botao-entrar"

                    >{props.realizandoProcessamento ? "Aguarde..." : "Entrar" }
                    </button>

                    <button className={estilosBotoes.botaoPrimario}
                            id="IniciarOrcamento_BotaoCancelar"
                            onClick={() => props.onCancelar()}>Cancelar
                    </button>
                </div>
            </div>
        </div>
    </>
}
